module.exports = __webpack_public_path__ + "img/I58A5040@2x.0f6eaa85.png";